<template>
	<div id="workBlock">
    <!-- <formSelectDadata :refs="'WORK_JOB'"></formSelectDadata> -->
    <instDadata :fieldName="'WORK_JOB'"></instDadata>

    <!-- <formSelectDadata :refs="'WORK_TITLE'"></formSelectDadata> -->
    <instDadata :fieldName="'WORK_TITLE'"></instDadata>

		<!-- <formSelect :refs="'EXPER_RADIO'"></formSelect> -->
    <instSelect :fieldName="'EXPER_RADIO'"></instSelect>

		<!-- <formInput :refs="'CONST_INCOME'"></formInput> -->
    <instInput :fieldName="'CONST_INCOME'"></instInput>

		<!-- <formInput :refs="'AVERAGE_EXPENSES_PER_MONTH'"></formInput> -->
    <instInput :fieldName="'AVERAGE_EXPENSES_PER_MONTH'"></instInput>

		<!-- <formInput :refs="'AVERAGE_MONTHLY_EXPENSES_FOR_LOAN_PAYMENTS'"></formInput> -->
    <instInput :fieldName="'AVERAGE_MONTHLY_EXPENSES_FOR_LOAN_PAYMENTS'"></instInput>

		<!-- <formInput :refs="'OTHER_SOURCES_OF_INCOME'"></formInput> -->
    <instInput :fieldName="'OTHER_SOURCES_OF_INCOME'"></instInput>

		<!-- <formSelect :refs="'SOURCE_OF_INCOME'"></formSelect> -->
    <instSelect :fieldName="'SOURCE_OF_INCOME'"></instSelect>

		<!-- <formSelect :refs="'PURPOSE_OF_THE_LOAN'" :firstValueSetActive="true"></formSelect> -->
    <instSelect :fieldName="'PURPOSE_OF_THE_LOAN'"></instSelect>

		<!-- <formSelect :refs="'FINANCIAL_POSITION'" :firstValueSetActive="true"></formSelect> -->
    <instSelect :fieldName="'FINANCIAL_POSITION'"></instSelect>

		<!-- <formSelect :refs="'EDUCATION'"></formSelect> -->
    <instSelect :fieldName="'EDUCATION'"></instSelect>

		<!-- <formSelect :refs="'MARITAL_STATUS'"></formSelect> -->
    <instSelect :fieldName="'MARITAL_STATUS'"></instSelect>

    <div v-show="getSelectedDeal.vwIsPdl === '0'">
      <!-- <formInput :refs="'MEETING_DATE'"></formInput> -->
      <instInput :fieldName="'MEETING_DATE'"></instInput>

      <!-- <formInput :refs="'MEETING_HOUR'"></formInput> -->
      <instInput :fieldName="'MEETING_HOUR'"></instInput>
    </div>

		<!-- <formCheckBox :name="'MINOR_CHILDREN'" :trueValue="true" :falseValue="false"></formCheckBox> -->
    <instCheckBox :fieldName="'MINOR_CHILDREN'"></instCheckBox>


          <!-- <formCheckBox style="margin-bottom: 0" :name="'NOT_RELATED'" :trueValue="true" :falseValue="false"></formCheckBox> -->
          <instCheckBox :fieldName="'NOT_RELATED'">
            <template v-slot:content>
              <p>Я не являюсь лицом или родственником<br class="mobileOnly">любого из лиц, перечисленных ниже:</p>
              <a href="#" v-on:click="cdSpoiler(0,$event)" v-show="!spolier">Подробне</a>
              <a href="#" v-on:click="cdSpoiler(0,$event)" v-show="spolier">Скрыть</a>

              <div class="forSpoiler" v-show="spolier">
                <div>
                  <div>
                    <p>Лицом, на которое возложено или было возложено ранее (с момента сложения
                      полномочий прошло менее 1 года) исполнение важных государственных функций, в
                      частности: - Главой государства (в том числе правящей королевской династии)
                      или правительства; - Министром, его заместителем или помощником; - Высшим
                      правительственным чиновником; - Должностным лицом судебных органов власти
                      (Верховный, Конституционный суд); - Государственным прокурором и его
                      заместителем; - Высшим военным чиновником; - Руководителем или членом Совета
                      директоров Национальных Банков; - Послом; - Руководителем государственных
                      корпораций; - Членом Парламента или иного законодательного органа.</p>
                  </div>
                  <div>
                    <p>Лицом, облеченным общественным доверием, в частности: - Руководителем,
                      заместителем руководителя международных организаций (ООН, ОЭСР, ОПЕК,
                      Олимпийский комитет, Всемирный Банк и т.д.); - Членом Европарламента; -
                      Руководителем или членом международных судебных организаций (Суд по правам
                      человека, Гаагский трибунал и др.).</p>
                  </div>
                  <div>
                    <p>Должностным лицом публичной международной организации, т.е. лицом,
                      уполномоченным такой организацией действовать от ее имени</p>
                  </div>
                  <div>
                    <p> Лицом, замещающим (занимающим) одну из перечисленных должностей: -
                      государственную должность Российской Федерации; - должность члена Совета
                      директоров Центрального банка Российской Федерации; - должность федеральной
                      государственной службы, назначение на которую и освобождение от которой
                      осуществляются Президентом Российской Федерации или Правительством
                      Российской Федерации; - должность в Центральном банке Российской Федерации;
                      - должность в государственной корпорации; - должности в иных организациях,
                      созданных Российской Федерацией на основании федеральных законов, включенные
                      в перечни должностей, определяемые Президентом Российской Федерации</p>
                  </div>
                  <div>
                    <p>Родственником вышеуказанной категории лиц, в частности: - Супругом; -
                      Родственником по прямой восходящей и нисходящей линии (родителями и детьми,
                      дедушкой, бабушкой и внуками); - Полнородным или не полнородным (имеющими
                      общих отца или мать) братом или сестрой, усыновителем или усыновленным</p>
                  </div>
                </div>
              </div>

              <a href="#" v-on:click="cdSpoiler(1,$event)" v-show="spolier">Скрыть</a>
            </template>
          </instCheckBox>

    <!-- <formCheckBox :name="'MY_OWN_BENEFIT'" :trueValue="true" :falseValue="false"></formCheckBox> -->
    <instCheckBox :fieldName="'MY_OWN_BENEFIT'"></instCheckBox>

    <!-- <formCheckBox :name="'ACTIONS_CONTROL'" :trueValue="true" :falseValue="false"></formCheckBox> -->
    <instCheckBox :fieldName="'ACTIONS_CONTROL'"></instCheckBox>

    <!-- <div id="lazyKostil">
      <formCheckBox :name="'AGREEMENT_RECURENT'" :trueValue="true" :falseValue="false"></formCheckBox>
      <a href="https://finmoll.ru/backend/content/documents/agreement_recurring_payments" target="_blank">Открыть документ</a>
    </div> -->
    <instCheckBox :fieldName="'AGREEMENT_RECURENT'"></instCheckBox>

		<div>
			<div v-if="!outerForm" class="optionButton">
				<p class="misc">Заполните дополнительные поля<br> это повысит вероятность одобрения</p>
				<button v-on:click="outerForm = true" class="instButton">Заполнить</button>
			</div>
			<div v-else>
				<!-- <formInput :refs="'CONTACT'"></formInput> -->
        <instInput :fieldName="'CONTACT'"></instInput>

				<!-- <formInput :refs="'CONTACT_PHONE'"></formInput> -->
        <instInput :fieldName="'CONTACT_PHONE'"></instInput>

				<!-- <formInput :refs="'WORK_JOB_INN'"></formInput> -->
        <instInput :fieldName="'WORK_JOB_INN'"></instInput>

				<!-- <formInput :refs="'WORK_JOB_PHONE'"></formInput> -->
        <instInput :fieldName="'WORK_JOB_PHONE'"></instInput>
			</div>

		</div>

	</div>
</template>

<script>
  //todo OTHER_SOURCES_OF_INCOME если не трогали, на бек надо отдать 0,  а то null может дров наломать
  import {mapGetters} from "vuex";

  export default {
		name: "workInfo",
		data(){
			return {
				outerForm:false,
        spolier:false,
			}
		},
		components:{
			// formInput:    () => import('@/views/pdlloan/formInput'),
      // formSelectDadata: () => import('@/views/pdlloan/formSelectDadata'),
			// formSelect:   () => import('@/views/pdlloan/formSelect'),
			// formCheckBox: () => import('@/views/pdlloan/formCheckBox'),
      instDadata: () => import('@/components/inst/instInputDadata.vue'),
      instSelect: () => import('@/components/inst/instSelect.vue'),
      instInput: () => import('@/components/inst/instInput.vue'),
      instCheckBox: () => import('@/components/inst/instCheckBox.vue'),
		},
		methods:{
      /**
       * открывает скрывает подробное описание кем пользователь не является
       * @param position int 0 без скрола, 1 со скролом в начало текста спойлера, что бы пользователя не бросало в
       * подвал страницы
       * @param $event событие, для блокировки работы тега a по умолчанию
       */
      cdSpoiler(position,$event){
        $event.preventDefault();
        this.spolier = !this.spolier;
        if (position === 1) {
          this.$emit('scrollingTo', {
            id:'mnogabukov',
          });
        }
      }
    },
    watch: {
    },
    computed: {
      ...mapGetters(['getSelectedDeal'])
    },
		mounted() {
      this.$emit('scrollingTo', {
        id:'zform',
      });
    }
	}
</script>

<style scoped>
.optionButton{margin: var(--font-size-20) 0; padding: var(--font-size-20) 0;text-align: center;border-top:1px solid var(--color-gray-type1);border-bottom:1px solid var(--color-gray-type1)}
.optionButton button{margin-top: var(--font-size-20);}
/* #anketaSteps > div > div > div { display: flex; flex-direction: column; }
button { border-radius: 2.67vw; width: 58.82vw }
/deep/.checkBoxWrap { margin-bottom: 6.47vw }
.misc { font-family: 'Lato-Bold'; margin-bottom: 7.65vw }
.forSpoiler{height: 0;transition: 0.3s ease-out;overflow: hidden}
.forSpoiler > div > div > p { color: #959595 }
.forSpoiler > div > div { margin-bottom: 1vw }
.spolier { height: auto }
#mnogabukov  { margin-bottom: 4.71vw }
#mnogabukov > a { color: #43AC34 }
#mnogabukov > div { display: flex; align-items: center; }
#mnogabukov > div > input { width: 8.24vw; height: 8.24vw; margin-right: 2.65vw }
#mnogabukov > div > div > p { color: #959595 }
#mnogabukov > div > div > a { color: #43AC34 }
#workBlock > div > div > label { display: flex; margin-bottom: 4.71vw }
#workBlock > div > div > label > input { width: 8.24vw; height: 8.24vw; margin-right: 2.65vw }
#workBlock > div > div > label > p { color: #959595 }

#lazyKostil > div{  margin-bottom: 3.53vw }


@media (min-width: 760px) {
  #mnogabukov  { margin-bottom: 1.13vw }
  #mnogabukov > a { }
  #mnogabukov > div > input { width: 2.26vw; height: 2.26vw; margin-right: 0.65vw  }
  #mnogabukov > div > div > p { }
  #mnogabukov > div > div > a { }
  .misc { font-size: 2.02vw; margin-bottom: 0 }
  #workBlock > div > div > label { margin-bottom: 1.13vw }
  #workBlock > div > div > label > input { width: 2.26vw; height: 2.26vw; margin-right: 0.65vw }
  #workBlock > div > div > label > p { }
  .forSpoiler > div > div > p { color: #959595 }
  .forSpoiler > div > div { margin-bottom: 1vw }
  #anketaSteps #workBlock > div > .optionButton { display: flex; flex-direction: row; margin-right: 0.65vw; margin-bottom: 2.82vw }
  #anketaSteps #workBlock > div > .optionButton > button { border-radius: 10px; width: 16.13vw; }
  #lazyKostil > div{ margin-bottom: 1.29vw; }
}
@media (min-width: 1240px) {
  #mnogabukov  { margin-bottom: 1.13vw }
  #mnogabukov > a { }
  #mnogabukov > div > input { width: 28px; height: 28px; margin-right: 8px  }
  #mnogabukov > div > div > p { }
  #mnogabukov > div > div > a { }
  .misc { font-size: 25px; margin-right: 8px }
  /deep/.checkBoxWrap { margin-bottom: 23px }
  #workBlock > div > div > label { margin-bottom: 1.13vw }
  #workBlock > div > div > label > input { width: 28px; height: 28px; margin-right: 8px }
  #workBlock > div > div > label > p { }
  .forSpoiler > div > div > p { }
  .forSpoiler > div > div { margin-bottom: 1vw }
  #anketaSteps #workBlock > div > .optionButton { margin-right: 8px; margin-bottom: 35px }
  #anketaSteps #workBlock > div > .optionButton > button { border-radius: 10px; width: 200px; height: 50px}
  #lazyKostil > div{ margin-bottom: 0px }
} */
</style>
